import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromApp from "../../store/app.reducer";
import * as selectors from "../../store/app.selectors";
import * as _ from "lodash";
import {
  auditTime,
  catchError,
  distinctUntilChanged,
  first,
  retry,
  tap,
} from "rxjs/operators";
import { Router } from "@angular/router";
import { DataStorageService } from "../data-storage/data-storage.service";
import * as DeliveryMethodAddressActions from "../../store/deliveryMethodAddress/deliveryMethodAddress.actions";
import { AlertController, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { NotValidAddressModalComponent } from "src/app/address/not-valid-address-modal/not-valid-address-modal.component";
import * as currentStoreActions from "../../store/current-store/current-store.actions";
import { SelectStorePopupComponent } from "src/app/popups/select-store-popup/select-store-popup.component";
import * as manuallyTriggeredActions from "../../store/manuallyTriggerFinalPriceCheckAddress/manuallyTriggerFinalPrice.actions";
import { AnalyticsServiceService } from "../analitycsService/analytics-service.service";
import { SelectStoreImagePopupComponent } from "src/app/popups/select-store-image-popup/select-store-image-popup.component";
import * as AuthActions from "../../auth/store/auth.actions";
import { VisitorSessionAssistService } from "../visitor-session-assist/visitor-session-assist.service";
import {
  getDeliveryVisitorAddressErrorKey,
  isUsableDeliveryVisitorAddress,
} from "./delivery-visitor-address.helpers";

@Injectable({
  providedIn: "root",
})
export class SelectedAddressService {
  public orderPickup: any;
  public dineIn: any;
  public selectedAddressForCheck: any;
  public selectedAddress: any;
  private currentStoreId: any;
  private openSelectStorePopupDelivery: any;
  private triggerCheckAddressTimestamp: any = null;
  private notValidAddressModal: any;
  private selectStoreModal: any;
  private navigationOnDeliveryMethodChange: any;
  private updated_address_from_check_selected_address = null;
  private loginState;
  private waitingLoginState = false;
  private waitingLoginStateManuallyTrigger = false;
  constructor(
    private http: HttpClient,
    private store: Store<fromApp.AppState>,
    private router: Router,
    private dataStorageService: DataStorageService,
    private alertController: AlertController,
    private translateService: TranslateService,
    private modalController: ModalController,
    private analyticsService: AnalyticsServiceService,
    private visitorSessionAssistService: VisitorSessionAssistService
  ) {}

  checkToSelectAddressSubs() {
    this.store
      .select("auth")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (state && !_.isEqual(state.loginState, this.loginState)) {
          this.loginState = _.cloneDeep(state.loginState);
          if (
            this.loginState &&
            this.loginState !== "login_loading" &&
            this.waitingLoginState
          ) {
            this.waitingLoginState = false;
            if (this.hasAddressToCheck()) {
              this.selectedAddressCheck(false);
            }
          }
          if (
            this.loginState &&
            this.loginState !== "login_loading" &&
            this.waitingLoginStateManuallyTrigger
          ) {
            this.waitingLoginStateManuallyTrigger = false;
            if (this.hasAddressToCheck()) {
              this.selectedAddressCheck(true);
            }
          }
        }
      });

    this.store
      .select("manuallyTriggerFinalPriceCheckAddress")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          state.triggerCheckAddressTimestamp &&
          !_.isEqual(
            this.triggerCheckAddressTimestamp,
            state.triggerCheckAddressTimestamp
          )
        ) {
          this.triggerCheckAddressTimestamp = _.cloneDeep(
            state.triggerCheckAddressTimestamp
          );
          if (this.selectedAddress) {
            this.selectedAddressForCheck = _.cloneDeep(this.selectedAddress);
            this.store.dispatch(
              new DeliveryMethodAddressActions.setCheckSelectedAddress(
                this.selectedAddressForCheck
              )
            );
            if (this.loginState && this.loginState !== "login_loading") {
              this.selectedAddressCheck(true);
            } else {
              this.waitingLoginStateManuallyTrigger = true;
            }
          }
        }
      });

    this.store
      .select("currentStore")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          state.currentStoreId &&
          !_.isEqual(state.currentStoreId, this.currentStoreId)
        ) {
          this.currentStoreId = _.cloneDeep(state.currentStoreId);
        }
      });
    this.store
      .select("deliveryMethodAddress")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
          this.orderPickup = _.cloneDeep(state.orderPickup);
        }
        if (state && !_.isEqual(this.dineIn, state.dineIn)) {
          this.dineIn = _.cloneDeep(state.dineIn);
        }
        if (state && !_.isEqual(this.selectedAddress, state.selectedAddress)) {
          this.selectedAddress = _.cloneDeep(state.selectedAddress);
        }
        if (
          state &&
          !_.isEqual(this.selectedAddressForCheck, state.checkSelectedAddress)
        ) {
          this.selectedAddressForCheck = _.cloneDeep(
            state.checkSelectedAddress
          );

          if (!state.selectedAddressLoading && this.selectedAddressForCheck) {
            if (this.loginState && this.loginState !== "login_loading") {
              this.selectedAddressCheck(false);
            } else {
              this.waitingLoginState = true;
            }
          }
        }
        if (
          state &&
          !_.isEqual(
            state.navigationOnDeliveryMethodChange,
            this.navigationOnDeliveryMethodChange
          )
        ) {
          this.navigationOnDeliveryMethodChange = _.cloneDeep(
            state.navigationOnDeliveryMethodChange
          );
        }
      });
  }

  selectedAddressCheckActions(manuallyTriggered, groupAppState) {
    if (groupAppState && groupAppState.selectedLangugage) {
      this.store.dispatch(
        new DeliveryMethodAddressActions.setSelectedAddressLoading(true)
      );

      if (manuallyTriggered) {
        this.store.dispatch(
          new manuallyTriggeredActions.SetCheckAddresssLoading(true)
        );
        this.store.dispatch(
          new manuallyTriggeredActions.SetCheckAddressSuccess(false)
        );
      }
      this.checkFormattedAddress(manuallyTriggered, groupAppState);
    }
  }

  // `selectedAddressLoading` is switched on in `selectedAddressCheckActions`
  // and is only switched back off by the address check's own handlers. The
  // re-arm gate in `checkToSelectAddressSubs` starts a new check only while
  // the flag is false, so any path that leaves it on strands the user: the
  // address modal renders its list, its action button and its close button
  // all disabled, with no error and no retry. Every early exit must come
  // through here.
  private clearSelectedAddressLoadingFlags(manuallyTriggered = false) {
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddressLoading(false)
    );
    // Only the manual flow owns `checkAddressLoading`. Seven components read
    // that key, so clearing it from a background check would kill a manual
    // check's spinner that is still legitimately running.
    if (manuallyTriggered) {
      this.store.dispatch(
        new manuallyTriggeredActions.SetCheckAddresssLoading(false)
      );
    }
  }

  // A check that waited for the login state wakes up on the auth slice, which
  // this service reads synchronously, while `selectedAddressForCheck` follows
  // the address slice through auditTime(100). logoutErase() clears the address
  // slice and then sets no_login in the same tick, so the cached address is
  // stale by then: read the slice itself (1248h536z0k).
  private hasAddressToCheck(): boolean {
    let checkSelectedAddress = null;
    this.store
      .select("deliveryMethodAddress")
      .pipe(first())
      .subscribe((state) => {
        checkSelectedAddress = state ? state.checkSelectedAddress : null;
      })
      .unsubscribe();
    return !!checkSelectedAddress;
  }

  // Every caller of prepareDeliveryVisitorAddress returns on null without
  // clearing the loading flags, because the stop path clears them. A null
  // address that passes through unchanged - cleared while its check was in
  // flight, e.g. by a logout - must end the selection the same way, silently:
  // there is nothing for the user to fix (1248h536z0k).
  private addressOrEndSelection(address: any): any {
    if (address) {
      return address;
    }
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddressLoading(false)
    );
    this.store.dispatch(
      new manuallyTriggeredActions.SetCheckAddresssLoading(false)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCheckSelectedAddress(null)
    );
    return null;
  }

  getStores() {
    return new Promise((resolve) => {
      this.store
        .select("stores")
        .pipe(first())
        .subscribe((state) => {
          resolve(state.stores);
        })
        .unsubscribe();
    });
  }

  private async getAuthState(): Promise<any> {
    return new Promise((resolve) => {
      this.store
        .select("auth")
        .pipe(first())
        .subscribe((state) => resolve(state || {}))
        .unsubscribe();
    });
  }

  private async stopDeliveryVisitorAddressSelection(
    commentId: string = "errorMessages.general_error"
  ): Promise<null> {
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddressLoading(false)
    );
    this.store.dispatch(
      new manuallyTriggeredActions.SetCheckAddresssLoading(false)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCheckSelectedAddress(null)
    );

    const alert = await this.alertController.create({
      header: this.translateService.instant("alert"),
      message: this.translateService.instant(commentId),
      buttons: ["OK"],
    });
    await alert.present();
    return null;
  }

  private dropUnusableStoredDeliveryVisitorAddress(): void {
    if (!navigator.cookieEnabled) {
      return;
    }
    try {
      const deliveryMethodAddress = JSON.parse(
        window.localStorage.getItem("deliveryMethodAddress")
      );
      if (
        deliveryMethodAddress &&
        deliveryMethodAddress.selectedAddress != null &&
        !isUsableDeliveryVisitorAddress(deliveryMethodAddress.selectedAddress)
      ) {
        deliveryMethodAddress.selectedAddress = null;
        window.localStorage.setItem(
          "deliveryMethodAddress",
          JSON.stringify(deliveryMethodAddress)
        );
      }
    } catch (e) {}
  }

  private async prepareDeliveryVisitorAddress(
    storeId: any,
    address: any
  ): Promise<any> {
    const authBefore = await this.getAuthState();
    if (authBefore.user && !authBefore.user.only_visitor) {
      return this.addressOrEndSelection(address);
    }

    const stores: any = await this.getStores();
    const storeInfo = _.find(stores, { store_id: storeId });
    if (!storeInfo) {
      return await this.stopDeliveryVisitorAddressSelection();
    }

    const deliveryVisitorEligible =
      this.visitorSessionAssistService.isDeliveryStoreEligible(storeInfo);
    if (deliveryVisitorEligible && !isUsableDeliveryVisitorAddress(address)) {
      // Never claim a visitor slot for an address updateCustomerData is certain
      // to reject (null, the "again" sentinel, a placeholder with "null"
      // fields). Drop an unusable persisted selectedAddress too, so the next
      // app open does not replay it, and ask the guest to pick the address
      // again: nothing was sent (1248h534k1a).
      this.dropUnusableStoredDeliveryVisitorAddress();
      return await this.stopDeliveryVisitorAddressSelection(
        "errorMessages.an-error-occurred-please-select-address-again"
      );
    }
    await this.visitorSessionAssistService.reconcileVisitorSessionForMode(
      storeInfo,
      "delivery"
    );

    const authAfter = await this.getAuthState();
    const visitorUser = authAfter.user;
    const isAlignedDeliveryVisitor = !!(
      visitorUser &&
      visitorUser.only_visitor &&
      visitorUser.visitor_mode === "delivery" &&
      _.isEqual(visitorUser.visitor_store_id, storeId)
    );

    if (!isAlignedDeliveryVisitor) {
      if (deliveryVisitorEligible) {
        return await this.stopDeliveryVisitorAddressSelection();
      }
      return this.addressOrEndSelection(address);
    }

    const response: any = await new Promise((resolve) => {
      this.dataStorageService
        .updateCustomerData(
          { updatedData: { addresses: [_.cloneDeep(address)] } },
          authAfter.mo_token
        )
        .pipe(first())
        .subscribe({
          next: (res: any) => resolve(res),
          error: () => resolve(null),
        });
    });

    if (!response || !response.success || !response.data) {
      return await this.stopDeliveryVisitorAddressSelection(
        getDeliveryVisitorAddressErrorKey(
          response?.comment_id,
          (key) => this.translateService.instant(key) !== key
        )
      );
    }

    const savedAddress = _.find(response.data.addresses, {
      address_id: address.address_id,
    });
    if (!savedAddress) {
      return await this.stopDeliveryVisitorAddressSelection();
    }

    this.store.dispatch(new AuthActions.SetUser(_.cloneDeep(response.data)));
    return _.cloneDeep(savedAddress);
  }

  selectedAddressCheck(manuallyTriggered) {
    //console.log("selected address check current url", this.router.url);

    this.store
      .select("auth")
      .pipe(first())
      .subscribe(async (authState) => {
        this.store
          .select("groupApp")
          .pipe(first())
          .subscribe(async (groupAppState) => {
            if (
              groupAppState &&
              groupAppState.groupApp &&
              groupAppState.groupApp.vatBasedCustomerAddressesActive
            ) {
              if (authState && authState.user) {
                const currentUser = _.cloneDeep(authState.user);

                const addressFound = _.find(currentUser.addresses, {
                  address_id: this.selectedAddressForCheck.address_id,
                  migration_customer_id: authState.migration_customer_id,
                });
                console.log("address found", addressFound);

                if (!addressFound) {
                  this.clearDeliveryMethod();
                } else {
                  if (groupAppState.groupApp.checkAddressesDisabled) {
                    const allStores: any = await this.getStores();
                    this.selectedAddressWithoutChecks(
                      allStores,
                      manuallyTriggered
                    );
                  } else {
                    this.selectedAddressCheckActions(
                      manuallyTriggered,
                      groupAppState
                    );
                  }
                }
              }
            } else {
              if (groupAppState.groupApp.checkAddressesDisabled) {
                const allStores: any = await this.getStores();
                this.selectedAddressWithoutChecks(allStores, manuallyTriggered);
              } else {
                this.selectedAddressCheckActions(
                  manuallyTriggered,
                  groupAppState
                );
              }
            }
          });
      });
  }

  clearDeliveryMethod() {
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddress(_.cloneDeep(null))
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setValidStores(_.cloneDeep(null))
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setValidDeliveryAreas(_.cloneDeep(null))
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setOpenNotValidAddressModal(false)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(false)
    );
    this.store.dispatch(new DeliveryMethodAddressActions.setDineIn(null));
    this.store.dispatch(new DeliveryMethodAddressActions.setOrderPickup(null));
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedDineInTable(null)
    );

    this.store.dispatch(
      new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCarTakewayComments(null)
    );
    // This is the app's own "start the delivery method over" routine - cart
    // validation calls it the moment it finds no delivery address. It cleared
    // ten delivery keys but not the loading flag, so a session whose flag had
    // latched stayed locked: the address list, the action button and even the
    // close button are all bound to it, and on native the hardware back button
    // cannot dismiss that modal either. Releasing it here turns every instance
    // of that class of bug from "restart the app" into "tap checkout again".
    // On any healthy flow the flag is already false, so this is a no-op.
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddressLoading(false)
    );

    if (navigator.cookieEnabled) {
      let deliveryMethodAddressObj: any = localStorage.getItem(
        "deliveryMethodAddress"
      );
      if (deliveryMethodAddressObj) {
        deliveryMethodAddressObj = JSON.parse(deliveryMethodAddressObj);
        deliveryMethodAddressObj.dineIn = null;
        deliveryMethodAddressObj.orderPickup = null;
        deliveryMethodAddressObj.selectedAddress = null;
        deliveryMethodAddressObj.selectedDineInTable = null;
        deliveryMethodAddressObj.carTakeAwayComments = null;
        deliveryMethodAddressObj.carTakeAwayPlateNumber = null;

        localStorage.setItem(
          "deliveryMethodAddress",
          JSON.stringify(deliveryMethodAddressObj)
        );
      }
    }
  }

  async presentSelectStoreModal(validStores) {
    this.store
      .select("groupApp")
      .pipe(first())
      .subscribe(async (state) => {
        if (
          state &&
          state.groupApp &&
          state.groupApp.images_select_store_mobileorder
        ) {
          this.selectStoreModal = await this.modalController.create({
            component: SelectStoreImagePopupComponent,
            cssClass: "selectStoreImagePopup",
            backdropDismiss: true,
            componentProps: { showValidStores: true },
          });
        } else {
          this.selectStoreModal = await this.modalController.create({
            component: SelectStorePopupComponent,
            cssClass: "selectStoreInPaymentCardsPopup",
            backdropDismiss: false,
            componentProps: { showValidStores: true },
          });
        }

        await this.selectStoreModal.present();
        this.selectStoreModal.onDidDismiss().then(async (data) => {
          this.selectStoreModal = null;
          //When you select a store calling selectStoreToSaveCard in order to checkPaymentGatewaysPopup
          if (data && data.data && data.data.selectedStoreId) {
            this.store
              .select("cart")
              .pipe(first())
              .subscribe(async (cart) => {
                if (cart && cart.products && cart.products.length > 0) {
                  // console.log("cart Products length", cart);
                  if (
                    this.currentStoreId &&
                    !_.isEqual(this.currentStoreId, data.data.selectedStoreId)
                  ) {
                    const alert = await this.alertController.create({
                      cssClass: "my-custom-class",
                      header: this.translateService.instant("alert"),
                      backdropDismiss: false,
                      message: this.translateService.instant(
                        "delivery-method-address.if-you-change-store-your-cart-products-will-be-deleted-do-you-want-to-continue"
                      ),
                      buttons: [
                        {
                          text: this.translateService.instant("cancel"),
                          role: "cancel",
                          cssClass: "secondary",
                          handler: () => {
                            if (!this.selectedAddress) {
                              if (navigator.cookieEnabled) {
                                let deliveryMethodAddress =
                                  localStorage.getItem("deliveryMethodAddress");
                                if (deliveryMethodAddress) {
                                  localStorage.removeItem(
                                    "deliveryMethodAddress"
                                  );
                                }
                              }
                              this.store.dispatch(
                                new DeliveryMethodAddressActions.setDineIn(null)
                              );
                              this.store.dispatch(
                                new DeliveryMethodAddressActions.setOrderPickup(
                                  null
                                )
                              );

                              this.store.dispatch(
                                new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                                  null
                                )
                              );
                              this.store.dispatch(
                                new DeliveryMethodAddressActions.setCarTakewayComments(
                                  null
                                )
                              );

                              this.store.dispatch(
                                new DeliveryMethodAddressActions.setSelectedAddress(
                                  _.cloneDeep(null)
                                )
                              );
                              this.store.dispatch(
                                new DeliveryMethodAddressActions.setValidStores(
                                  _.cloneDeep(null)
                                )
                              );
                              this.store.dispatch(
                                new DeliveryMethodAddressActions.setValidDeliveryAreas(
                                  _.cloneDeep(null)
                                )
                              );
                              this.store.dispatch(
                                new DeliveryMethodAddressActions.setOpenNotValidAddressModal(
                                  false
                                )
                              );
                              this.store.dispatch(
                                new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
                                  false
                                )
                              );
                              this.openSelectStorePopupDelivery = "again";
                            }
                            this.selectedAddressForCheck = "again";

                            this.store.dispatch(
                              new DeliveryMethodAddressActions.setSelectedAddressLoading(
                                false
                              )
                            );
                            this.store.dispatch(
                              new manuallyTriggeredActions.SetCheckAddresssLoading(
                                false
                              )
                            );
                            this.store.dispatch(
                              new DeliveryMethodAddressActions.setCheckSelectedAddress(
                                null
                              )
                            );
                            this.openSelectStorePopupDelivery = "again";

                            this.store.dispatch(
                              new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
                                false
                              )
                            );
                          },
                        },
                        {
                          text: this.translateService.instant("yes"),
                          handler: () => {
                            this.selectStoreModalSetAddress(data);
                          },
                        },
                      ],
                    });
                    await alert.present();
                  } else if (
                    this.currentStoreId &&
                    _.isEqual(this.currentStoreId, data.data.selectedStoreId)
                  ) {
                    this.selectStoreModalSetAddress(data);
                  }
                } else if (
                  (cart && !cart.products) ||
                  (cart.products && cart.products.length === 0)
                ) {
                  this.selectStoreModalSetAddress(data);
                }
              })
              .unsubscribe();
          } else {
            this.store.dispatch(
              new DeliveryMethodAddressActions.setDineIn(null)
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setOrderPickup(null)
            );

            this.store.dispatch(
              new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setCarTakewayComments(null)
            );

            this.store.dispatch(
              new DeliveryMethodAddressActions.setSelectedAddressLoading(false)
            );
            this.store.dispatch(
              new manuallyTriggeredActions.SetCheckAddresssLoading(false)
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setSelectedAddress(
                _.cloneDeep(null)
              )
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setValidStores(_.cloneDeep(null))
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setValidDeliveryAreas(
                _.cloneDeep(null)
              )
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setOpenNotValidAddressModal(
                false
              )
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
                false
              )
            );
            if (navigator.cookieEnabled) {
              let deliveryMethodAddress = localStorage.getItem(
                "deliveryMethodAddress"
              );
              if (deliveryMethodAddress) {
                localStorage.removeItem("deliveryMethodAddress");
              }
            }
            this.openSelectStorePopupDelivery = "again";
          }
        });
      })
      .unsubscribe();
  }

  selectStoreModalSetAddress(data) {
    this.store
      .select("auth")
      .pipe(first())
      .subscribe(async (authState) => {
        console.log(
          "set store id selected address service",
          data.data.selectedStoreId
        );
        this.store.dispatch(
          new currentStoreActions.SetCurrentStoreId(
            _.cloneDeep(data.data.selectedStoreId)
          )
        );

        this.store.dispatch(
          new DeliveryMethodAddressActions.setOrderPickup(false)
        );
        this.store.dispatch(
          new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
        );
        this.store.dispatch(
          new DeliveryMethodAddressActions.setCarTakewayComments(null)
        );
        this.store.dispatch(new DeliveryMethodAddressActions.setDineIn(false));
        this.store.dispatch(
          new DeliveryMethodAddressActions.setSelectedDineInTable(
            _.cloneDeep(null)
          )
        );
        this.analyticsService.dmAnalyticsMessage(
          "delivery_method",
          null,
          null,
          null,
          null,
          null,
          null,
          this.selectedAddressForCheck,
          null,
          null,
          null
        );
        if (navigator.cookieEnabled) {
          let deliveryMethodAddress = JSON.parse(
            window.localStorage.getItem("deliveryMethodAddress")
          );

          if (deliveryMethodAddress) {
            deliveryMethodAddress.orderPickup = false;
            deliveryMethodAddress.dineIn = false;
            deliveryMethodAddress.selectedDineInTable = null;
            deliveryMethodAddress.carTakeAwayPlateNumber = null;
            deliveryMethodAddress.carTakeAwayComments = null;
          } else {
            deliveryMethodAddress = {
              orderPickup: false,
              dineIn: false,
            };
          }
          window.localStorage.setItem(
            "deliveryMethodAddress",
            JSON.stringify(deliveryMethodAddress)
          );
        }
        let selectedAddress = _.cloneDeep(this.selectedAddressForCheck);
        if (
          selectedAddress &&
          authState &&
          authState.user &&
          authState.user.addresses
        ) {
          const findAddress = _.find(_.cloneDeep(authState.user.addresses), {
            address_id: this.selectedAddressForCheck.address_id,
          });
          if (
            findAddress &&
            !_.isEqual(findAddress, this.selectedAddressForCheck)
          ) {
            selectedAddress = _.cloneDeep(findAddress);
          }
        }

        if (
          selectedAddress &&
          this.updated_address_from_check_selected_address &&
          selectedAddress.address_id ===
            this.updated_address_from_check_selected_address.address_id &&
          !_.isEqual(
            this.updated_address_from_check_selected_address,
            selectedAddress
          )
        ) {
          selectedAddress = _.assign(
            selectedAddress,
            _.cloneDeep(this.updated_address_from_check_selected_address)
          );
        }

        selectedAddress = await this.prepareDeliveryVisitorAddress(
          data.data.selectedStoreId,
          selectedAddress
        );
        if (!selectedAddress) {
          // Release the select-store latch as the success path below does, or
          // the next multi-store check compares equal and never answers.
          this.openSelectStorePopupDelivery = "again";
          this.store.dispatch(
            new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
              false
            )
          );
          return;
        }

        this.store.dispatch(
          new DeliveryMethodAddressActions.setSelectedAddressLoading(false)
        );
        this.store.dispatch(
          new manuallyTriggeredActions.SetCheckAddresssLoading(false)
        );

        this.store.dispatch(
          new DeliveryMethodAddressActions.setSelectedAddress(
            _.cloneDeep(selectedAddress)
          )
        );
        this.store.dispatch(
          new DeliveryMethodAddressActions.setCheckSelectedAddress(
            _.cloneDeep(null)
          )
        );
        if (navigator.cookieEnabled) {
          if (window.localStorage.getItem("deliveryMethodAddress")) {
            let deliveryMethodAddress = JSON.parse(
              window.localStorage.getItem("deliveryMethodAddress")
            );
            deliveryMethodAddress.selectedAddress = selectedAddress;
            window.localStorage.setItem(
              "deliveryMethodAddress",
              JSON.stringify(deliveryMethodAddress)
            );
          } else {
            let deliveryMethodAddress = {
              orderPickup: this.orderPickup,
              dineIn: this.dineIn,
              selectedAddress: selectedAddress,
            };
            window.localStorage.setItem(
              "deliveryMethodAddress",
              JSON.stringify(deliveryMethodAddress)
            );
          }
          if (
            (this.router.url === "/homepage" ||
              this.router.url === "/ratings" ||
              this.router.url === "/orders" ||
              this.router.url === "/points") &&
            this.navigationOnDeliveryMethodChange
          ) {
            this.router.navigateByUrl("/catalog", {
              replaceUrl: true,
            });
          }
        }
        this.selectedAddressForCheck = null;
        this.openSelectStorePopupDelivery = "again";
        this.store.dispatch(
          new DeliveryMethodAddressActions.setOpenNotValidAddressModal(false)
        );
        this.store.dispatch(
          new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
            false
          )
        );
      })
      .unsubscribe();
  }

  async presentNotValidAddressModal(notValidAddress) {
    this.notValidAddressModal = await this.modalController.create({
      component: NotValidAddressModalComponent,
      cssClass: "my-custom-class",
      componentProps: {
        notValidAddress: _.cloneDeep(notValidAddress),
      },
      backdropDismiss: false,
    });
    await this.notValidAddressModal.present();
    this.notValidAddressModal.onDidDismiss().then((data) => {
      this.notValidAddressModal = null;
    });
  }

  public deselectAddress() {
    if (navigator.cookieEnabled) {
      if (window.localStorage.getItem("deliveryMethodAddress")) {
        let deliveryMethodAddress = JSON.parse(
          window.localStorage.getItem("deliveryMethodAddress")
        );
        deliveryMethodAddress.selectedAddress = null;
        deliveryMethodAddress.orderPickup = null;
        deliveryMethodAddress.dineIn = null;
        window.localStorage.setItem(
          "deliveryMethodAddress",
          JSON.stringify(deliveryMethodAddress)
        );
      }
    }
    this.store.dispatch(new DeliveryMethodAddressActions.setDineIn(null));
    this.store.dispatch(new DeliveryMethodAddressActions.setOrderPickup(null));
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCarTakewayComments(null)
    );

    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddressLoading(false)
    );
    this.store.dispatch(
      new manuallyTriggeredActions.SetCheckAddresssLoading(false)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCheckSelectedAddress(null)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddress(_.cloneDeep(null))
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setValidStores(_.cloneDeep(null))
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setValidDeliveryAreas(_.cloneDeep(null))
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setOpenNotValidAddressModal(false)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(false)
    );
  }

  public closeAddressModals() {
    if (this.notValidAddressModal) {
      this.notValidAddressModal.dismiss();
      this.notValidAddressModal = null;
    }

    if (this.selectStoreModal) {
      this.selectStoreModal.dismiss();
      this.selectStoreModal = null;
    }
  }

  selectedAddressWithoutChecks(validStores, manuallyTriggered) {
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddressLoading(true)
    );

    if (manuallyTriggered) {
      this.store.dispatch(
        new manuallyTriggeredActions.SetCheckAddresssLoading(true)
      );
      this.store.dispatch(
        new manuallyTriggeredActions.SetCheckAddressSuccess(false)
      );
    }
    setTimeout(async () => {
      // A null or empty list matches neither branch below, so the flags would
      // stay on for good. `getStores()` resolves the stores slice, whose
      // initial value is null, so this is reachable before the slice loads.
      // Release the UI only - the delivery method itself is left alone.
      if (!validStores || _.isEmpty(validStores)) {
        console.log("selected address without checks: no valid stores");
        this.clearSelectedAddressLoadingFlags(manuallyTriggered);
        this.selectedAddressForCheck = null;
        this.store.dispatch(
          new DeliveryMethodAddressActions.setCheckSelectedAddress(null)
        );
        return;
      }
      if (validStores && validStores.length === 1) {
        if (
          this.currentStoreId &&
          _.isEqual(validStores[0].store_id, this.currentStoreId)
        ) {
          console.log(
            "set store id selected address service",
            validStores[0].store_id
          );
          this.store.dispatch(
            new currentStoreActions.SetCurrentStoreId(
              _.cloneDeep(validStores[0].store_id)
            )
          );

          this.store.dispatch(
            new DeliveryMethodAddressActions.setValidStores(
              _.cloneDeep(validStores)
            )
          );

          this.store.dispatch(
            new DeliveryMethodAddressActions.setOrderPickup(false)
          );
          this.store.dispatch(
            new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
          );
          this.store.dispatch(
            new DeliveryMethodAddressActions.setCarTakewayComments(null)
          );
          //console.log("set order pickup false");
          this.store.dispatch(
            new DeliveryMethodAddressActions.setDineIn(false)
          );
          this.store.dispatch(
            new DeliveryMethodAddressActions.setSelectedDineInTable(
              _.cloneDeep(null)
            )
          );
          this.analyticsService.dmAnalyticsMessage(
            "delivery_method",
            null,
            null,
            null,
            null,
            null,
            null,
            this.selectedAddressForCheck,
            null,
            null,
            null
          );
          if (navigator.cookieEnabled) {
            let deliveryMethodAddress = JSON.parse(
              window.localStorage.getItem("deliveryMethodAddress")
            );

            if (deliveryMethodAddress) {
              deliveryMethodAddress.orderPickup = false;
              deliveryMethodAddress.dineIn = false;
              deliveryMethodAddress.selectedDineInTable = null;
              deliveryMethodAddress.carTakeAwayPlateNumber = null;
              deliveryMethodAddress.carTakeAwayComments = null;
            } else {
              deliveryMethodAddress = {
                orderPickup: false,
                dineIn: false,
              };
            }
            window.localStorage.setItem(
              "deliveryMethodAddress",
              JSON.stringify(deliveryMethodAddress)
            );
          }
          let selectedAdd = _.cloneDeep(this.selectedAddressForCheck);
          selectedAdd = await this.prepareDeliveryVisitorAddress(
            validStores[0].store_id,
            selectedAdd
          );
          if (!selectedAdd) {
            return;
          }

          this.store.dispatch(
            new DeliveryMethodAddressActions.setSelectedAddressLoading(false)
          );
          this.store.dispatch(
            new manuallyTriggeredActions.SetCheckAddresssLoading(false)
          );

          this.store.dispatch(
            new DeliveryMethodAddressActions.setSelectedAddress(
              _.cloneDeep(selectedAdd)
            )
          );
          if (
            (this.router.url === "/homepage" ||
              this.router.url === "/ratings" ||
              this.router.url === "/orders" ||
              this.router.url === "/points") &&
            this.navigationOnDeliveryMethodChange
          ) {
            this.router.navigate(["catalog"]);
          }
          this.store.dispatch(
            new DeliveryMethodAddressActions.setCheckSelectedAddress(
              _.cloneDeep(null)
            )
          );
          if (navigator.cookieEnabled) {
            if (window.localStorage.getItem("deliveryMethodAddress")) {
              let deliveryMethodAddress = JSON.parse(
                window.localStorage.getItem("deliveryMethodAddress")
              );
              deliveryMethodAddress.selectedAddress = selectedAdd;
              window.localStorage.setItem(
                "deliveryMethodAddress",
                JSON.stringify(deliveryMethodAddress)
              );
            } else {
              let deliveryMethodAddress = {
                orderPickup: this.orderPickup,
                dineIn: this.dineIn,
                selectedAddress: selectedAdd,
              };
              window.localStorage.setItem(
                "deliveryMethodAddress",
                JSON.stringify(deliveryMethodAddress)
              );
            }
          }
          this.selectedAddressForCheck = null;
        } else if (
          this.currentStoreId &&
          !_.isEqual(validStores[0].store_id, this.currentStoreId)
        ) {
          //console.log("here");
          this.store
            .select("cart")
            .pipe(first())
            .subscribe(async (state) => {
              if (state && state.products && state.products.length > 0) {
                const alert = await this.alertController.create({
                  cssClass: "my-custom-class",
                  header: this.translateService.instant("alert"),
                  backdropDismiss: false,
                  message: this.translateService.instant(
                    "delivery-method-address.if-you-change-store-your-cart-products-will-be-deleted-do-you-want-to-continue"
                  ),
                  buttons: [
                    {
                      text: this.translateService.instant("cancel"),
                      role: "cancel",
                      cssClass: "secondary",
                      handler: () => {
                        if (!this.selectedAddress) {
                          if (navigator.cookieEnabled) {
                            window.localStorage.removeItem(
                              "deliveryMethodAddress"
                            );
                          }
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setDineIn(null)
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setOrderPickup(
                              null
                            )
                          );

                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                              null
                            )
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setCarTakewayComments(
                              null
                            )
                          );

                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setSelectedAddress(
                              _.cloneDeep(null)
                            )
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setValidStores(
                              _.cloneDeep(null)
                            )
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setValidDeliveryAreas(
                              _.cloneDeep(null)
                            )
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setOpenNotValidAddressModal(
                              false
                            )
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
                              false
                            )
                          );
                          this.openSelectStorePopupDelivery = "again";
                        }
                        this.selectedAddressForCheck = "again";
                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setSelectedAddressLoading(
                            false
                          )
                        );
                        this.store.dispatch(
                          new manuallyTriggeredActions.SetCheckAddresssLoading(
                            false
                          )
                        );
                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setCheckSelectedAddress(
                            null
                          )
                        );
                      },
                    },

                    {
                      text: this.translateService.instant("yes"),
                      handler: async () => {
                        console.log(
                          "set store id selected address service",
                          validStores[0].store_id
                        );
                        this.store.dispatch(
                          new currentStoreActions.SetCurrentStoreId(
                            _.cloneDeep(validStores[0].store_id)
                          )
                        );

                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setValidStores(
                            _.cloneDeep(validStores)
                          )
                        );

                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                            null
                          )
                        );
                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setCarTakewayComments(
                            null
                          )
                        );

                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setOrderPickup(false)
                        );
                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setDineIn(false)
                        );
                        this.analyticsService.dmAnalyticsMessage(
                          "delivery_method",
                          null,
                          null,
                          null,
                          null,
                          null,
                          null,
                          null,
                          null,
                          null,
                          null
                        );
                        if (navigator.cookieEnabled) {
                          let deliveryMethodAddressObj: any =
                            localStorage.getItem("deliveryMethodAddress");
                          if (deliveryMethodAddressObj) {
                            deliveryMethodAddressObj = JSON.parse(
                              deliveryMethodAddressObj
                            );
                            if (deliveryMethodAddressObj) {
                              deliveryMethodAddressObj.orderPickup = false;
                              deliveryMethodAddressObj.dineIn = false;
                            } else {
                              deliveryMethodAddressObj = {
                                orderPickup: false,
                                dineIn: false,
                              };
                            }
                          } else {
                            deliveryMethodAddressObj = {
                              orderPickup: false,
                              dineIn: false,
                            };
                          }

                          window.localStorage.setItem(
                            "deliveryMethodAddress",
                            JSON.stringify(deliveryMethodAddressObj)
                          );
                        }
                        let selectedAdd = _.cloneDeep(
                          this.selectedAddressForCheck
                        );
                        selectedAdd = await this.prepareDeliveryVisitorAddress(
                          validStores[0].store_id,
                          selectedAdd
                        );
                        if (!selectedAdd) {
                          return;
                        }

                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setSelectedAddressLoading(
                            false
                          )
                        );
                        this.store.dispatch(
                          new manuallyTriggeredActions.SetCheckAddresssLoading(
                            false
                          )
                        );

                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setSelectedAddress(
                            _.cloneDeep(selectedAdd)
                          )
                        );
                        if (
                          (this.router.url === "/homepage" ||
                            this.router.url === "/ratings" ||
                            this.router.url === "/orders" ||
                            this.router.url === "/points") &&
                          this.navigationOnDeliveryMethodChange
                        ) {
                          this.router.navigateByUrl("/catalog", {
                            replaceUrl: true,
                          });
                        }
                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setCheckSelectedAddress(
                            _.cloneDeep(null)
                          )
                        );
                        if (navigator.cookieEnabled) {
                          if (
                            window.localStorage.getItem("deliveryMethodAddress")
                          ) {
                            let deliveryMethodAddress = JSON.parse(
                              window.localStorage.getItem(
                                "deliveryMethodAddress"
                              )
                            );
                            deliveryMethodAddress.selectedAddress = selectedAdd;
                            window.localStorage.setItem(
                              "deliveryMethodAddress",
                              JSON.stringify(deliveryMethodAddress)
                            );
                          } else {
                            let deliveryMethodAddress = {
                              orderPickup: this.orderPickup,
                              dineIn: this.dineIn,
                              selectedAddress: selectedAdd,
                            };
                            window.localStorage.setItem(
                              "deliveryMethodAddress",
                              JSON.stringify(deliveryMethodAddress)
                            );
                          }
                        }
                        this.selectedAddressForCheck = null;
                      },
                    },
                  ],
                });
                await alert.present();
              } else if (
                (state && state.products && state.products.length === 0) ||
                (state && !state.products)
              ) {
                console.log(
                  "set store id selected address service",
                  validStores[0].store_id
                );
                this.store.dispatch(
                  new currentStoreActions.SetCurrentStoreId(
                    _.cloneDeep(validStores[0].store_id)
                  )
                );

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setValidStores(
                    _.cloneDeep(validStores)
                  )
                );

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setOrderPickup(false)
                );

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                    null
                  )
                );
                this.store.dispatch(
                  new DeliveryMethodAddressActions.setCarTakewayComments(null)
                );

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setDineIn(false)
                );
                this.analyticsService.dmAnalyticsMessage(
                  "delivery_method",
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  this.selectedAddressForCheck,
                  null,
                  null,
                  null
                );
                if (navigator.cookieEnabled) {
                  let deliveryMethodAddressObj: any = localStorage.getItem(
                    "deliveryMethodAddress"
                  );
                  if (deliveryMethodAddressObj) {
                    deliveryMethodAddressObj = JSON.parse(
                      deliveryMethodAddressObj
                    );
                    if (deliveryMethodAddressObj) {
                      deliveryMethodAddressObj.orderPickup = false;
                      deliveryMethodAddressObj.dineIn = false;
                    } else {
                      deliveryMethodAddressObj = {
                        orderPickup: false,
                        dineIn: false,
                      };
                    }
                  } else {
                    deliveryMethodAddressObj = {
                      orderPickup: false,
                      dineIn: false,
                    };
                  }

                  window.localStorage.setItem(
                    "deliveryMethodAddress",
                    JSON.stringify(deliveryMethodAddressObj)
                  );
                }
                let selectedAdd = _.cloneDeep(this.selectedAddressForCheck);
                selectedAdd = await this.prepareDeliveryVisitorAddress(
                  validStores[0].store_id,
                  selectedAdd
                );
                if (!selectedAdd) {
                  return;
                }

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setSelectedAddressLoading(
                    false
                  )
                );
                this.store.dispatch(
                  new manuallyTriggeredActions.SetCheckAddresssLoading(false)
                );

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setSelectedAddress(
                    _.cloneDeep(selectedAdd)
                  )
                );
                if (
                  (this.router.url === "/homepage" ||
                    this.router.url === "/ratings" ||
                    this.router.url === "/orders" ||
                    this.router.url === "/points") &&
                  this.navigationOnDeliveryMethodChange
                ) {
                  this.router.navigateByUrl("/catalog", {
                    replaceUrl: true,
                  });
                }
                this.store.dispatch(
                  new DeliveryMethodAddressActions.setCheckSelectedAddress(
                    _.cloneDeep(null)
                  )
                );
                if (navigator.cookieEnabled) {
                  if (window.localStorage.getItem("deliveryMethodAddress")) {
                    let deliveryMethodAddress = JSON.parse(
                      window.localStorage.getItem("deliveryMethodAddress")
                    );
                    deliveryMethodAddress.selectedAddress = selectedAdd;
                    window.localStorage.setItem(
                      "deliveryMethodAddress",
                      JSON.stringify(deliveryMethodAddress)
                    );
                  } else {
                    let deliveryMethodAddress = {
                      orderPickup: this.orderPickup,
                      dineIn: this.dineIn,
                      selectedAddress: selectedAdd,
                    };
                    window.localStorage.setItem(
                      "deliveryMethodAddress",
                      JSON.stringify(deliveryMethodAddress)
                    );
                  }
                }
                this.selectedAddressForCheck = null;
              }
            })
            .unsubscribe();
        } else {
          // Mirror of the fix in `checkFormattedAddress`: both branches above
          // require a truthy `currentStoreId`, and this is the only address
          // path for groups with `checkAddressesDisabled`, so without this
          // else those groups keep the latch untouched. The window is wider
          // here - the branch is reached after a fixed 800ms timer rather
          // than a network round trip.
          console.log(
            "selected address without checks: single valid store but no current store id"
          );
          this.clearSelectedAddressLoadingFlags(manuallyTriggered);
          this.selectedAddressForCheck = null;
          this.store.dispatch(
            new DeliveryMethodAddressActions.setCheckSelectedAddress(null)
          );
          // Return so the blanket `SetCheckAddressSuccess(true)` at the end of
          // this timer does not mark a check that assigned nothing successful.
          if (manuallyTriggered) {
            this.store.dispatch(
              new manuallyTriggeredActions.SetCheckAddressSuccess(false)
            );
          }
          return;
        }
      } else if (validStores && validStores.length > 1) {
        this.store.dispatch(
          new DeliveryMethodAddressActions.setValidStores(
            _.cloneDeep(validStores)
          )
        );

        this.store
          .select("deliveryMethodAddress")
          .pipe(first())
          .subscribe(async (state) => {
            if (
              state &&
              !_.isEqual(
                state.openSelectStorePopupDelivery,
                this.openSelectStorePopupDelivery
              )
            ) {
              this.openSelectStorePopupDelivery = _.cloneDeep(
                state.openSelectStorePopupDelivery
              );
              if (this.openSelectStorePopupDelivery) {
                // console.log("present select store modal");

                this.presentSelectStoreModal(validStores);
              } else if (!this.openSelectStorePopupDelivery) {
                //console.log("present select store modal else");

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setOrderPickup(false)
                );
                this.store.dispatch(
                  new DeliveryMethodAddressActions.setDineIn(false)
                );

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                    null
                  )
                );
                this.store.dispatch(
                  new DeliveryMethodAddressActions.setCarTakewayComments(null)
                );

                this.analyticsService.dmAnalyticsMessage(
                  "delivery_method",
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  this.selectedAddressForCheck,
                  null,
                  null,
                  null
                );
                if (navigator.cookieEnabled) {
                  let deliveryMethodAddress = JSON.parse(
                    window.localStorage.getItem("deliveryMethodAddress")
                  );

                  if (deliveryMethodAddress) {
                    deliveryMethodAddress.orderPickup = false;
                    deliveryMethodAddress.dineIn = false;
                  } else {
                    deliveryMethodAddress = {
                      orderPickup: false,
                      dineIn: false,
                    };
                  }
                  window.localStorage.setItem(
                    "deliveryMethodAddress",
                    JSON.stringify(deliveryMethodAddress)
                  );
                }

                let selectedAdd = _.cloneDeep(this.selectedAddressForCheck);
                selectedAdd = await this.prepareDeliveryVisitorAddress(
                  this.currentStoreId,
                  selectedAdd
                );
                if (!selectedAdd) {
                  return;
                }

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setSelectedAddressLoading(
                    false
                  )
                );
                this.store.dispatch(
                  new manuallyTriggeredActions.SetCheckAddresssLoading(false)
                );

                this.store.dispatch(
                  new DeliveryMethodAddressActions.setSelectedAddress(
                    _.cloneDeep(selectedAdd)
                  )
                );
                if (
                  (this.router.url === "/homepage" ||
                    this.router.url === "/ratings" ||
                    this.router.url === "/orders" ||
                    this.router.url === "/points") &&
                  this.navigationOnDeliveryMethodChange
                ) {
                  this.router.navigateByUrl("/catalog", {
                    replaceUrl: true,
                  });
                }
                this.store.dispatch(
                  new DeliveryMethodAddressActions.setCheckSelectedAddress(
                    _.cloneDeep(null)
                  )
                );
                if (navigator.cookieEnabled) {
                  if (window.localStorage.getItem("deliveryMethodAddress")) {
                    let deliveryMethodAddress = JSON.parse(
                      window.localStorage.getItem("deliveryMethodAddress")
                    );
                    deliveryMethodAddress.selectedAddress = selectedAdd;
                    window.localStorage.setItem(
                      "deliveryMethodAddress",
                      JSON.stringify(deliveryMethodAddress)
                    );
                  } else {
                    let deliveryMethodAddress = {
                      orderPickup: this.orderPickup,
                      dineIn: this.dineIn,
                      selectedAddress: selectedAdd,
                    };
                    window.localStorage.setItem(
                      "deliveryMethodAddress",
                      JSON.stringify(deliveryMethodAddress)
                    );
                  }
                }
                this.selectedAddressForCheck = null;
                this.openSelectStorePopupDelivery = "again";
              }
            }
          })
          .unsubscribe();
      }

      if (manuallyTriggered) {
        this.store.dispatch(
          new manuallyTriggeredActions.SetCheckAddressSuccess(true)
        );
      }
    }, 800);
  }

  checkFormattedAddress(manuallyTriggered, groupState) {
    // Guard the unguarded dereferences below. The reachable one is a null
    // `selectedAddressForCheck`: every successful check nulls it out, and the
    // `waitingLoginState` entry point in `checkToSelectAddressSubs` calls back
    // in without re-checking it. A throw here happens inside an RxJS subscribe
    // callback, so it never reaches this request's own error handler - the
    // flag would simply never clear.
    if (!groupState || !groupState.groupApp || !this.selectedAddressForCheck) {
      console.log("check formatted address: missing address or group context");
      this.clearSelectedAddressLoadingFlags(manuallyTriggered);
      return;
    }
    this.store
      .select("stores")
      .pipe(first())
      .subscribe((storesState) => {
        this.store
          .select("auth")
          .pipe(first())
          .subscribe((authState) => {
            const allStores = storesState.stores;
            this.updated_address_from_check_selected_address = null;
            let checkFormattedAddressRequest;
            try {
              checkFormattedAddressRequest =
                this.dataStorageService.checkFormattedAddress(
                  groupState.groupApp.group,
                  this.selectedAddressForCheck.userLat,
                  this.selectedAddressForCheck.userLng,
                  groupState.selectedLangugage,
                  authState && authState.user && !authState.user.only_visitor
                    ? authState.user.customer_id
                    : null,
                  this.selectedAddressForCheck.address_id
                );
            } catch (err) {
              // Belt and braces for anything the guard above does not cover.
              console.log("check formatted address: request build failed", err);
              this.clearSelectedAddressLoadingFlags(manuallyTriggered);
              return;
            }
            checkFormattedAddressRequest
              .subscribe({
                next: async (res: any) => {
                  if (!res || !res.success) {
                    if (manuallyTriggered) {
                      this.store.dispatch(
                        new manuallyTriggeredActions.SetCheckAddressSuccess(
                          false
                        )
                      );
                    }
                    const alert = await this.alertController.create({
                      header: this.translateService.instant("alert"),
                      message:
                        res && res.comment_id
                          ? this.translateService.instant(res.comment_id)
                          : this.translateService.instant(
                              "errorMessages.general_error"
                            ),

                      buttons: ["OK"],
                    });
                    await alert.present();

                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setSelectedAddressLoading(
                        false
                      )
                    );
                    this.store.dispatch(
                      new manuallyTriggeredActions.SetCheckAddresssLoading(
                        false
                      )
                    );
                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setCheckSelectedAddress(
                        _.cloneDeep(null)
                      )
                    );
                  } else {
                    if (
                      res &&
                      res.updated_customer &&
                      !_.isEmpty(res.updated_customer) &&
                      !(authState && authState.user && authState.user.only_visitor)
                    ) {
                      this.store.dispatch(
                        new AuthActions.SetUser(
                          _.cloneDeep(res.updated_customer)
                        )
                      );
                    }

                    if (
                      res &&
                      res.updated_address &&
                      !_.isEmpty(res.updated_address)
                    ) {
                      this.updated_address_from_check_selected_address =
                        res.updated_address;
                    }

                    let validStores = _.filter(
                      res.validStores,
                      (validStore) => {
                        if (
                          _.find(allStores, { store_id: validStore.store_id })
                        ) {
                          return validStore;
                        }
                      }
                    );

                    let validDeliveryAreas = _.filter(
                      res.deliveryAreas,
                      (deliveryArea) => {
                        if (
                          _.find(allStores, { store_id: deliveryArea.store_id })
                        ) {
                          return deliveryArea;
                        }
                      }
                    );

                    if (!validStores || _.isEmpty(validStores)) {
                      this.store.dispatch(
                        new DeliveryMethodAddressActions.setOrderPickup(null)
                      );
                      this.store.dispatch(
                        new DeliveryMethodAddressActions.setDineIn(null)
                      );
                      this.store.dispatch(
                        new DeliveryMethodAddressActions.setValidDeliveryAreas(
                          null
                        )
                      );

                      this.store.dispatch(
                        new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                          null
                        )
                      );
                      this.store.dispatch(
                        new DeliveryMethodAddressActions.setCarTakewayComments(
                          null
                        )
                      );

                      this.store.dispatch(
                        new DeliveryMethodAddressActions.setSelectedAddressLoading(
                          false
                        )
                      );
                      this.store.dispatch(
                        new manuallyTriggeredActions.SetCheckAddresssLoading(
                          false
                        )
                      );

                      if (
                        navigator.cookieEnabled &&
                        window.localStorage.getItem("deliveryMethodAddress")
                      ) {
                        let deliveryMethodAddress = JSON.parse(
                          window.localStorage.getItem("deliveryMethodAddress")
                        );
                        //console.log("dddddd", deliveryMethodAddress);
                        if (
                          deliveryMethodAddress &&
                          deliveryMethodAddress.selectedAddress
                        ) {
                          //console.log("remove item called");
                          window.localStorage.removeItem(
                            "deliveryMethodAddress"
                          );
                        }
                      }
                      this.store
                        .select("deliveryMethodAddress")
                        .pipe(first())
                        .subscribe((state) => {
                          if (state && state.openNotValidAddressModal) {
                            const address = _.cloneDeep(
                              this.selectedAddressForCheck
                            );
                            setTimeout(() => {
                              this.presentNotValidAddressModal(address);
                            }, 200);

                            this.store.dispatch(
                              new DeliveryMethodAddressActions.setCheckSelectedAddress(
                                null
                              )
                            );
                            this.store.dispatch(
                              new DeliveryMethodAddressActions.setSelectedAddress(
                                null
                              )
                            );
                          }
                        })
                        .unsubscribe();
                      this.store.dispatch(
                        new DeliveryMethodAddressActions.setCheckSelectedAddress(
                          null
                        )
                      );
                      this.store.dispatch(
                        new DeliveryMethodAddressActions.setSelectedAddress(
                          null
                        )
                      );
                    } else {
                      if (validStores && validStores.length === 1) {
                        if (
                          this.currentStoreId &&
                          _.isEqual(
                            validStores[0].store_id,
                            this.currentStoreId
                          )
                        ) {
                          console.log(
                            "set store id selected address service",
                            validStores[0].store_id
                          );
                          this.store.dispatch(
                            new currentStoreActions.SetCurrentStoreId(
                              _.cloneDeep(validStores[0].store_id)
                            )
                          );

                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setValidStores(
                              _.cloneDeep(validStores)
                            )
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setValidDeliveryAreas(
                              _.cloneDeep(validDeliveryAreas)
                            )
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setOrderPickup(
                              false
                            )
                          );

                          //console.log("set order pickup false");
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setDineIn(false)
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setSelectedDineInTable(
                              _.cloneDeep(null)
                            )
                          );

                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                              null
                            )
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setCarTakewayComments(
                              null
                            )
                          );
                          this.analyticsService.dmAnalyticsMessage(
                            "delivery_method",
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            this.selectedAddressForCheck,
                            null,
                            null,
                            null
                          );
                          if (navigator.cookieEnabled) {
                            let deliveryMethodAddress = JSON.parse(
                              window.localStorage.getItem(
                                "deliveryMethodAddress"
                              )
                            );

                            if (deliveryMethodAddress) {
                              deliveryMethodAddress.orderPickup = false;
                              deliveryMethodAddress.dineIn = false;
                              deliveryMethodAddress.selectedDineInTable = null;
                              deliveryMethodAddress.carTakeAwayPlateNumber =
                                null;
                              deliveryMethodAddress.carTakeAwayComments = null;
                            } else {
                              deliveryMethodAddress = {
                                orderPickup: false,
                                dineIn: false,
                              };
                            }
                            window.localStorage.setItem(
                              "deliveryMethodAddress",
                              JSON.stringify(deliveryMethodAddress)
                            );
                          }
                          let selectedAdd = _.cloneDeep(
                            this.selectedAddressForCheck
                          );
                          if (
                            selectedAdd &&
                            res &&
                            res.updated_customer &&
                            !_.isEmpty(res.updated_customer)
                          ) {
                            const updatedAddress = _.find(
                              res.updated_customer.addresses,
                              { address_id: selectedAdd.address_id }
                            );

                            if (updatedAddress) {
                              selectedAdd = _.cloneDeep(updatedAddress);
                            }
                          }

                          if (
                            res &&
                            res.updated_address &&
                            !_.isEmpty(res.updated_address)
                          ) {
                            if (
                              selectedAdd &&
                              !_.isEqual(selectedAdd, res.updated_address) &&
                              selectedAdd.address_id ===
                                res.updated_address.address_id
                            ) {
                              selectedAdd = _.assign(
                                selectedAdd,
                                _.cloneDeep(res.updated_address)
                              );
                            }
                          }
                          selectedAdd =
                            await this.prepareDeliveryVisitorAddress(
                              validStores[0].store_id,
                              selectedAdd
                            );
                          if (!selectedAdd) {
                            return;
                          }
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setSelectedAddressLoading(
                              false
                            )
                          );
                          this.store.dispatch(
                            new manuallyTriggeredActions.SetCheckAddresssLoading(
                              false
                            )
                          );
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setSelectedAddress(
                              _.cloneDeep(selectedAdd)
                            )
                          );
                          if (
                            (this.router.url === "/homepage" ||
                              this.router.url === "/ratings" ||
                              this.router.url === "/orders" ||
                              this.router.url === "/points") &&
                            this.navigationOnDeliveryMethodChange
                          ) {
                            this.router.navigate(["catalog"]);
                          }
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setCheckSelectedAddress(
                              _.cloneDeep(null)
                            )
                          );
                          if (navigator.cookieEnabled) {
                            if (
                              window.localStorage.getItem(
                                "deliveryMethodAddress"
                              )
                            ) {
                              let deliveryMethodAddress = JSON.parse(
                                window.localStorage.getItem(
                                  "deliveryMethodAddress"
                                )
                              );
                              deliveryMethodAddress.selectedAddress =
                                selectedAdd;
                              window.localStorage.setItem(
                                "deliveryMethodAddress",
                                JSON.stringify(deliveryMethodAddress)
                              );
                            } else {
                              let deliveryMethodAddress = {
                                orderPickup: this.orderPickup,
                                dineIn: this.dineIn,
                                selectedAddress: selectedAdd,
                              };
                              window.localStorage.setItem(
                                "deliveryMethodAddress",
                                JSON.stringify(deliveryMethodAddress)
                              );
                            }
                          }
                          this.selectedAddressForCheck = null;
                        } else if (
                          this.currentStoreId &&
                          !_.isEqual(
                            validStores[0].store_id,
                            this.currentStoreId
                          )
                        ) {
                          //console.log("here");
                          this.store
                            .select("cart")
                            .pipe(first())
                            .subscribe(async (state) => {
                              if (
                                state &&
                                state.products &&
                                state.products.length > 0
                              ) {
                                const alert = await this.alertController.create(
                                  {
                                    cssClass: "my-custom-class",
                                    header:
                                      this.translateService.instant("alert"),
                                    backdropDismiss: false,
                                    message: this.translateService.instant(
                                      "delivery-method-address.if-you-change-store-your-cart-products-will-be-deleted-do-you-want-to-continue"
                                    ),
                                    buttons: [
                                      {
                                        text: this.translateService.instant(
                                          "cancel"
                                        ),
                                        role: "cancel",
                                        cssClass: "secondary",
                                        handler: () => {
                                          if (!this.selectedAddress) {
                                            if (navigator.cookieEnabled) {
                                              window.localStorage.removeItem(
                                                "deliveryMethodAddress"
                                              );
                                            }
                                            this.store.dispatch(
                                              new DeliveryMethodAddressActions.setDineIn(
                                                null
                                              )
                                            );
                                            this.store.dispatch(
                                              new DeliveryMethodAddressActions.setOrderPickup(
                                                null
                                              )
                                            );

                                            this.store.dispatch(
                                              new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                                                null
                                              )
                                            );
                                            this.store.dispatch(
                                              new DeliveryMethodAddressActions.setCarTakewayComments(
                                                null
                                              )
                                            );

                                            this.store.dispatch(
                                              new DeliveryMethodAddressActions.setSelectedAddress(
                                                _.cloneDeep(null)
                                              )
                                            );
                                            this.store.dispatch(
                                              new DeliveryMethodAddressActions.setValidStores(
                                                _.cloneDeep(null)
                                              )
                                            );
                                            this.store.dispatch(
                                              new DeliveryMethodAddressActions.setValidDeliveryAreas(
                                                _.cloneDeep(null)
                                              )
                                            );
                                            this.store.dispatch(
                                              new DeliveryMethodAddressActions.setOpenNotValidAddressModal(
                                                false
                                              )
                                            );
                                            this.store.dispatch(
                                              new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
                                                false
                                              )
                                            );
                                            this.openSelectStorePopupDelivery =
                                              "again";
                                          }
                                          this.selectedAddressForCheck =
                                            "again";
                                          this.store.dispatch(
                                            new DeliveryMethodAddressActions.setSelectedAddressLoading(
                                              false
                                            )
                                          );
                                          this.store.dispatch(
                                            new manuallyTriggeredActions.SetCheckAddresssLoading(
                                              false
                                            )
                                          );
                                          this.store.dispatch(
                                            new DeliveryMethodAddressActions.setCheckSelectedAddress(
                                              null
                                            )
                                          );
                                        },
                                      },

                                      {
                                        text: this.translateService.instant(
                                          "yes"
                                        ),
                                        handler: async () => {
                                          console.log(
                                            "set store id selected address service",
                                            validStores[0].store_id
                                          );
                                          this.store.dispatch(
                                            new currentStoreActions.SetCurrentStoreId(
                                              _.cloneDeep(
                                                validStores[0].store_id
                                              )
                                            )
                                          );

                                          this.store.dispatch(
                                            new DeliveryMethodAddressActions.setValidStores(
                                              _.cloneDeep(validStores)
                                            )
                                          );
                                          this.store.dispatch(
                                            new DeliveryMethodAddressActions.setValidDeliveryAreas(
                                              _.cloneDeep(validDeliveryAreas)
                                            )
                                          );
                                          this.store.dispatch(
                                            new DeliveryMethodAddressActions.setOrderPickup(
                                              false
                                            )
                                          );
                                          this.store.dispatch(
                                            new DeliveryMethodAddressActions.setDineIn(
                                              false
                                            )
                                          );
                                          this.analyticsService.dmAnalyticsMessage(
                                            "delivery_method",
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null
                                          );
                                          if (navigator.cookieEnabled) {
                                            let deliveryMethodAddressObj: any =
                                              localStorage.getItem(
                                                "deliveryMethodAddress"
                                              );
                                            if (deliveryMethodAddressObj) {
                                              deliveryMethodAddressObj =
                                                JSON.parse(
                                                  deliveryMethodAddressObj
                                                );
                                              if (deliveryMethodAddressObj) {
                                                deliveryMethodAddressObj.orderPickup =
                                                  false;
                                                deliveryMethodAddressObj.dineIn =
                                                  false;
                                              } else {
                                                deliveryMethodAddressObj = {
                                                  orderPickup: false,
                                                  dineIn: false,
                                                };
                                              }
                                            } else {
                                              deliveryMethodAddressObj = {
                                                orderPickup: false,
                                                dineIn: false,
                                              };
                                            }

                                            window.localStorage.setItem(
                                              "deliveryMethodAddress",
                                              JSON.stringify(
                                                deliveryMethodAddressObj
                                              )
                                            );
                                          }
                                          let selectedAdd = _.cloneDeep(
                                            this.selectedAddressForCheck
                                          );
                                          if (
                                            selectedAdd &&
                                            res &&
                                            res.updated_customer &&
                                            !_.isEmpty(res.updated_customer)
                                          ) {
                                            const updatedAddress = _.find(
                                              res.updated_customer.addresses,
                                              {
                                                address_id:
                                                  selectedAdd.address_id,
                                              }
                                            );

                                            if (updatedAddress) {
                                              selectedAdd =
                                                _.cloneDeep(updatedAddress);
                                            }
                                          }

                                          if (
                                            res &&
                                            res.updated_address &&
                                            !_.isEmpty(res.updated_address)
                                          ) {
                                            if (
                                              selectedAdd &&
                                              !_.isEqual(
                                                selectedAdd,
                                                res.updated_address
                                              ) &&
                                              selectedAdd.address_id ===
                                                res.updated_address.address_id
                                            ) {
                                              selectedAdd = _.assign(
                                                selectedAdd,
                                                _.cloneDeep(res.updated_address)
                                              );
                                            }
                                          }
                                          selectedAdd =
                                            await this.prepareDeliveryVisitorAddress(
                                              validStores[0].store_id,
                                              selectedAdd
                                            );
                                          if (!selectedAdd) {
                                            return;
                                          }
                                          this.store.dispatch(
                                            new DeliveryMethodAddressActions.setSelectedAddressLoading(
                                              false
                                            )
                                          );
                                          this.store.dispatch(
                                            new manuallyTriggeredActions.SetCheckAddresssLoading(
                                              false
                                            )
                                          );
                                          this.store.dispatch(
                                            new DeliveryMethodAddressActions.setSelectedAddress(
                                              _.cloneDeep(selectedAdd)
                                            )
                                          );
                                          if (
                                            (this.router.url === "/homepage" ||
                                              this.router.url === "/ratings" ||
                                              this.router.url === "/orders" ||
                                              this.router.url === "/points") &&
                                            this
                                              .navigationOnDeliveryMethodChange
                                          ) {
                                            this.router.navigateByUrl(
                                              "/catalog",
                                              {
                                                replaceUrl: true,
                                              }
                                            );
                                          }
                                          this.store.dispatch(
                                            new DeliveryMethodAddressActions.setCheckSelectedAddress(
                                              _.cloneDeep(null)
                                            )
                                          );
                                          if (navigator.cookieEnabled) {
                                            if (
                                              window.localStorage.getItem(
                                                "deliveryMethodAddress"
                                              )
                                            ) {
                                              let deliveryMethodAddress =
                                                JSON.parse(
                                                  window.localStorage.getItem(
                                                    "deliveryMethodAddress"
                                                  )
                                                );
                                              deliveryMethodAddress.selectedAddress =
                                                selectedAdd;
                                              window.localStorage.setItem(
                                                "deliveryMethodAddress",
                                                JSON.stringify(
                                                  deliveryMethodAddress
                                                )
                                              );
                                            } else {
                                              let deliveryMethodAddress = {
                                                orderPickup: this.orderPickup,
                                                dineIn: this.dineIn,
                                                selectedAddress: selectedAdd,
                                              };
                                              window.localStorage.setItem(
                                                "deliveryMethodAddress",
                                                JSON.stringify(
                                                  deliveryMethodAddress
                                                )
                                              );
                                            }
                                          }
                                          this.selectedAddressForCheck = null;
                                        },
                                      },
                                    ],
                                  }
                                );
                                await alert.present();
                              } else if (
                                (state &&
                                  state.products &&
                                  state.products.length === 0) ||
                                (state && !state.products)
                              ) {
                                console.log(
                                  "set store id selected address service",
                                  validStores[0].store_id
                                );
                                this.store.dispatch(
                                  new currentStoreActions.SetCurrentStoreId(
                                    _.cloneDeep(validStores[0].store_id)
                                  )
                                );

                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setValidStores(
                                    _.cloneDeep(validStores)
                                  )
                                );
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setValidDeliveryAreas(
                                    _.cloneDeep(validDeliveryAreas)
                                  )
                                );
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setOrderPickup(
                                    false
                                  )
                                );
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setDineIn(
                                    false
                                  )
                                );
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                                    null
                                  )
                                );
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setCarTakewayComments(
                                    null
                                  )
                                );

                                this.analyticsService.dmAnalyticsMessage(
                                  "delivery_method",
                                  null,
                                  null,
                                  null,
                                  null,
                                  null,
                                  null,
                                  this.selectedAddressForCheck,
                                  null,
                                  null,
                                  null
                                );
                                if (navigator.cookieEnabled) {
                                  let deliveryMethodAddressObj: any =
                                    localStorage.getItem(
                                      "deliveryMethodAddress"
                                    );
                                  if (deliveryMethodAddressObj) {
                                    deliveryMethodAddressObj = JSON.parse(
                                      deliveryMethodAddressObj
                                    );
                                    if (deliveryMethodAddressObj) {
                                      deliveryMethodAddressObj.orderPickup =
                                        false;
                                      deliveryMethodAddressObj.dineIn = false;

                                      deliveryMethodAddressObj.carTakeawayActive =
                                        null;
                                      deliveryMethodAddressObj.carTakeAwayComments =
                                        null;
                                    } else {
                                      deliveryMethodAddressObj = {
                                        orderPickup: false,
                                        dineIn: false,
                                      };
                                    }
                                  } else {
                                    deliveryMethodAddressObj = {
                                      orderPickup: false,
                                      dineIn: false,
                                    };
                                  }

                                  window.localStorage.setItem(
                                    "deliveryMethodAddress",
                                    JSON.stringify(deliveryMethodAddressObj)
                                  );
                                }
                                let selectedAdd = _.cloneDeep(
                                  this.selectedAddressForCheck
                                );

                                if (
                                  selectedAdd &&
                                  res &&
                                  res.updated_customer &&
                                  !_.isEmpty(res.updated_customer)
                                ) {
                                  const updatedAddress = _.find(
                                    res.updated_customer.addresses,
                                    { address_id: selectedAdd.address_id }
                                  );

                                  if (updatedAddress) {
                                    selectedAdd = _.cloneDeep(updatedAddress);
                                  }
                                }

                                if (
                                  res &&
                                  res.updated_address &&
                                  !_.isEmpty(res.updated_address)
                                ) {
                                  if (
                                    selectedAdd &&
                                    !_.isEqual(
                                      selectedAdd,
                                      res.updated_address
                                    ) &&
                                    selectedAdd.address_id ===
                                      res.updated_address.address_id
                                  ) {
                                    selectedAdd = _.assign(
                                      selectedAdd,
                                      _.cloneDeep(res.updated_address)
                                    );
                                  }
                                }
                                selectedAdd =
                                  await this.prepareDeliveryVisitorAddress(
                                    validStores[0].store_id,
                                    selectedAdd
                                  );
                                if (!selectedAdd) {
                                  return;
                                }
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setSelectedAddressLoading(
                                    false
                                  )
                                );
                                this.store.dispatch(
                                  new manuallyTriggeredActions.SetCheckAddresssLoading(
                                    false
                                  )
                                );
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setSelectedAddress(
                                    _.cloneDeep(selectedAdd)
                                  )
                                );
                                if (
                                  (this.router.url === "/homepage" ||
                                    this.router.url === "/ratings" ||
                                    this.router.url === "/orders" ||
                                    this.router.url === "/points") &&
                                  this.navigationOnDeliveryMethodChange
                                ) {
                                  this.router.navigateByUrl("/catalog", {
                                    replaceUrl: true,
                                  });
                                }
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setCheckSelectedAddress(
                                    _.cloneDeep(null)
                                  )
                                );
                                if (navigator.cookieEnabled) {
                                  if (
                                    window.localStorage.getItem(
                                      "deliveryMethodAddress"
                                    )
                                  ) {
                                    let deliveryMethodAddress = JSON.parse(
                                      window.localStorage.getItem(
                                        "deliveryMethodAddress"
                                      )
                                    );
                                    deliveryMethodAddress.selectedAddress =
                                      selectedAdd;
                                    window.localStorage.setItem(
                                      "deliveryMethodAddress",
                                      JSON.stringify(deliveryMethodAddress)
                                    );
                                  } else {
                                    let deliveryMethodAddress = {
                                      orderPickup: this.orderPickup,
                                      dineIn: this.dineIn,
                                      selectedAddress: selectedAdd,
                                    };
                                    window.localStorage.setItem(
                                      "deliveryMethodAddress",
                                      JSON.stringify(deliveryMethodAddress)
                                    );
                                  }
                                }
                                this.selectedAddressForCheck = null;
                              }
                            })
                            .unsubscribe();
                        } else {
                          // Both branches above require a truthy `currentStoreId`.
                          // When the check answers before the store is resolved
                          // (boot race) neither of them runs, and without this
                          // else `selectedAddressLoading` stays true for good -
                          // which disables the whole address modal: the address
                          // list, the action button and even the close button,
                          // with no error, no retry and no way out short of an
                          // app restart.
                          console.log(
                            "check formatted address: single valid store but no current store id"
                          );
                          this.clearSelectedAddressLoadingFlags(manuallyTriggered);
                          this.selectedAddressForCheck = null;
                          // Clearing `checkSelectedAddress` too is what makes the
                          // recovery real: the subscription re-arms on a CHANGED
                          // value, so leaving the old address in the slice would
                          // make tapping that same address again a complete
                          // no-op - enabled buttons that still do nothing.
                          this.store.dispatch(
                            new DeliveryMethodAddressActions.setCheckSelectedAddress(
                              null
                            )
                          );
                          // This check did NOT succeed - it never assigned a
                          // store or an address. Say so and return, because the
                          // blanket `SetCheckAddressSuccess(true)` at the end of
                          // this handler would otherwise mark it successful and
                          // let cart-list start its validation writing state on
                          // an address that was never validated.
                          if (manuallyTriggered) {
                            this.store.dispatch(
                              new manuallyTriggeredActions.SetCheckAddressSuccess(
                                false
                              )
                            );
                          }
                          return;
                        }
                      } else if (validStores && validStores.length > 1) {
                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setValidStores(
                            _.cloneDeep(validStores)
                          )
                        );
                        this.store.dispatch(
                          new DeliveryMethodAddressActions.setValidDeliveryAreas(
                            _.cloneDeep(validDeliveryAreas)
                          )
                        );
                        this.store
                          .select("deliveryMethodAddress")
                          .pipe(first())
                          .subscribe(async (state) => {
                            if (
                              state &&
                              !_.isEqual(
                                state.openSelectStorePopupDelivery,
                                this.openSelectStorePopupDelivery
                              )
                            ) {
                              this.openSelectStorePopupDelivery = _.cloneDeep(
                                state.openSelectStorePopupDelivery
                              );
                              if (this.openSelectStorePopupDelivery) {
                                // console.log("present select store modal");

                                this.presentSelectStoreModal(validStores);
                              } else if (!this.openSelectStorePopupDelivery) {
                                //console.log("present select store modal else");

                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setOrderPickup(
                                    false
                                  )
                                );
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setDineIn(
                                    false
                                  )
                                );

                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                                    null
                                  )
                                );
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setCarTakewayComments(
                                    null
                                  )
                                );

                                this.analyticsService.dmAnalyticsMessage(
                                  "delivery_method",
                                  null,
                                  null,
                                  null,
                                  null,
                                  null,
                                  null,
                                  this.selectedAddressForCheck,
                                  null,
                                  null,
                                  null
                                );
                                if (navigator.cookieEnabled) {
                                  let deliveryMethodAddress = JSON.parse(
                                    window.localStorage.getItem(
                                      "deliveryMethodAddress"
                                    )
                                  );

                                  if (deliveryMethodAddress) {
                                    deliveryMethodAddress.orderPickup = false;
                                    deliveryMethodAddress.dineIn = false;

                                    deliveryMethodAddress.carTakeawayActive =
                                      null;
                                    deliveryMethodAddress.carTakeAwayComments =
                                      null;
                                  } else {
                                    deliveryMethodAddress = {
                                      orderPickup: false,
                                      dineIn: false,
                                    };
                                  }
                                  window.localStorage.setItem(
                                    "deliveryMethodAddress",
                                    JSON.stringify(deliveryMethodAddress)
                                  );
                                }

                                let selectedAdd = _.cloneDeep(
                                  this.selectedAddressForCheck
                                );
                                if (
                                  selectedAdd &&
                                  res &&
                                  res.updated_customer &&
                                  !_.isEmpty(res.updated_customer)
                                ) {
                                  const updatedAddress = _.find(
                                    res.updated_customer.addresses,
                                    { address_id: selectedAdd.address_id }
                                  );

                                  if (updatedAddress) {
                                    selectedAdd = _.cloneDeep(updatedAddress);
                                  }
                                }

                                if (
                                  res &&
                                  res.updated_address &&
                                  !_.isEmpty(res.updated_address)
                                ) {
                                  if (
                                    selectedAdd &&
                                    !_.isEqual(
                                      selectedAdd,
                                      res.updated_address
                                    ) &&
                                    selectedAdd.address_id ===
                                      res.updated_address.address_id
                                  ) {
                                    selectedAdd = _.assign(
                                      selectedAdd,
                                      _.cloneDeep(res.updated_address)
                                    );
                                  }
                                }
                                selectedAdd =
                                  await this.prepareDeliveryVisitorAddress(
                                    this.currentStoreId,
                                    selectedAdd
                                  );
                                if (!selectedAdd) {
                                  return;
                                }

                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setSelectedAddressLoading(
                                    false
                                  )
                                );
                                this.store.dispatch(
                                  new manuallyTriggeredActions.SetCheckAddresssLoading(
                                    false
                                  )
                                );

                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setSelectedAddress(
                                    _.cloneDeep(selectedAdd)
                                  )
                                );
                                if (
                                  (this.router.url === "/homepage" ||
                                    this.router.url === "/ratings" ||
                                    this.router.url === "/orders" ||
                                    this.router.url === "/points") &&
                                  this.navigationOnDeliveryMethodChange
                                ) {
                                  this.router.navigateByUrl("/catalog", {
                                    replaceUrl: true,
                                  });
                                }
                                this.store.dispatch(
                                  new DeliveryMethodAddressActions.setCheckSelectedAddress(
                                    _.cloneDeep(null)
                                  )
                                );
                                if (navigator.cookieEnabled) {
                                  if (
                                    window.localStorage.getItem(
                                      "deliveryMethodAddress"
                                    )
                                  ) {
                                    let deliveryMethodAddress = JSON.parse(
                                      window.localStorage.getItem(
                                        "deliveryMethodAddress"
                                      )
                                    );
                                    deliveryMethodAddress.selectedAddress =
                                      selectedAdd;
                                    window.localStorage.setItem(
                                      "deliveryMethodAddress",
                                      JSON.stringify(deliveryMethodAddress)
                                    );
                                  } else {
                                    let deliveryMethodAddress = {
                                      orderPickup: this.orderPickup,
                                      dineIn: this.dineIn,
                                      selectedAddress: selectedAdd,
                                    };
                                    window.localStorage.setItem(
                                      "deliveryMethodAddress",
                                      JSON.stringify(deliveryMethodAddress)
                                    );
                                  }
                                }
                                this.selectedAddressForCheck = null;
                                this.openSelectStorePopupDelivery = "again";
                              }
                            }
                          })
                          .unsubscribe();
                      }
                    }
                    if (manuallyTriggered) {
                      this.store.dispatch(
                        new manuallyTriggeredActions.SetCheckAddressSuccess(
                          true
                        )
                      );
                    }
                  }
                },
                error: async (err) => {
                  const alert = await this.alertController.create({
                    header: this.translateService.instant("alert"),
                    message: this.translateService.instant(
                      "errorMessages.problem_reaching_server"
                    ),

                    buttons: ["OK"],
                  });
                  await alert.present();
                  if (manuallyTriggered) {
                    this.store.dispatch(
                      new manuallyTriggeredActions.SetCheckAddressSuccess(false)
                    );
                  }
                  this.store.dispatch(
                    new DeliveryMethodAddressActions.setSelectedAddressLoading(
                      false
                    )
                  );
                  this.store.dispatch(
                    new manuallyTriggeredActions.SetCheckAddresssLoading(false)
                  );
                  this.store.dispatch(
                    new DeliveryMethodAddressActions.setCheckSelectedAddress(
                      _.cloneDeep(null)
                    )
                  );
                  return err;
                },
              });
          })
          .unsubscribe();
      })
      .unsubscribe();
  }
}
